<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'material/index' }">
                                Bahan Ajar
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'material/subject', params: {gradeID: gradeSubject.gradeID} }">
                                {{ gradeSubject.grade.name  }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ gradeSubject.subject.name  }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mb-3">
                <h3>
                    {{ gradeSubject.grade.name  }} - {{ gradeSubject.subject.name  }}
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="card shadow-sm mb-4 border-0">
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Deskripsi Umum
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput($event)">
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="wrapper-input" v-if="roleElligibleModified()">
                                <div class="row mb-4">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <tinymce id="text-editor-grade-subject" v-model="gradeSubject.description" v-bind:other_options="tinyMCEOptions"></tinymce>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="ml-auto col-auto">
                                        <button type="submit" class="btn btn-danger btn-sm px-5">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput($event)">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="toggle-input">
                                <div class="row">
                                    <div class="col" v-html="gradeSubject.description"></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="card shadow-sm mb-4 border-0">
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Deskripsi Forum
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput($event)">
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="wrapper-input" v-if="roleElligibleModified()">
                                <div class="row mb-4">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <textarea v-model="gradeSubject.subtitle" class="form-control form-control-sm"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="ml-auto col-auto">
                                        <button type="submit" class="btn btn-danger btn-sm px-5">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput($event)">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="toggle-input">
                                <div class="row">
                                    <div class="col" v-html="gradeSubject.subtitle"></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" v-for="(material, materialIndex) in materials">
                <div class="card shadow-sm mb-4 border-0">
                    <form v-on:submit.prevent="update($event, materialIndex)" disabled>
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Materi {{ materialIndex + 1 }}
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput($event)">
                                            Edit
                                        </button>
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="confirmation(material)">
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="wrapper-input" v-if="roleElligibleModified()">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="font-weight-medium required text-muted">Judul</label>
                                            <input v-model="material.title" class="form-control form-control-sm" placeholder="Judul" required />
                                        </div>
                                        <div class="form-group">
                                            <label class="font-weight-medium required text-muted">Deskripsi</label>
                                            <tinymce v-bind:id="'text-editor-update-' + materialIndex" v-model="material.description" v-bind:other_options="tinyMCEOptions"></tinymce>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 col-md-6 mb-5">
                                                <label class="font-weight-medium required text-muted">File</label>
                                                <ol class="pl-4">
                                                    <li v-for="(file, index) in material.files">
                                                        <div class="row align-items-center justify-content-end">
                                                            <div class="col text-dark h4 mb-0 font-weight-medium">
                                                                <file-icon v-bind:type="file.fileExtension" class="mr-1"></file-icon> {{ file.filename }}
                                                            </div>
                                                            <div class="col-auto ml-auto">
                                                                <button class="btn btn-link btn-sm" type="button" v-on:click="removeFile(materialIndex, index)">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <input v-model="file.description" class="form-control form-control-sm mt-1 mb-3" placeholder="Deskripsi..." />
                                                            </div>
                                                        </div>
                                                    </li> 
                                                </ol>
                                                <input v-bind:id="'file-material-' + materialIndex" type="file" class="form-control" v-on:change="addFiles($event, materialIndex)" placeholder="Upload File" multiple="true" />
                                                <label v-bind:for="'file-material-' + materialIndex" class="btn btn-danger btn-sm px-4 ml-4">
                                                    Upload File
                                                </label>
                                            </div>
                                            <div class="col-12 col-md-6 mb-5">
                                                <label class="font-weight-medium required text-muted">Video</label>
                                                <div class="row">
                                                    <div class="col-12 mb-3" v-for="(video, index) in material.videos">
                                                        <div class="row align-items-center justify-content-end">
                                                            <div class="col-auto ml-auto">
                                                                <button class="btn btn-link btn-sm" type="button" v-on:click="removeVideo(materialIndex, index)">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <div class="input-group input-group-sm mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">https://youtube.com/watch?v=</span>
                                                                    </div>
                                                                    <input v-model="video.url" class="form-control form-control-sm" placeholder="Youtube ID..." required />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <input v-model="video.description" class="form-control form-control-sm" placeholder="Deskripsi..." />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button class="btn btn-danger btn-sm px-4" type="button" v-on:click="addVideo(materialIndex)">
                                                    + Add Video
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="ml-auto col-auto">
                                        <button type="submit" class="btn btn-danger btn-sm px-5">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput($event)">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="toggle-input">
                                <div class="card-title text-muted mb-0">
                                    Judul:
                                </div>
                                <p class="mb-2">
                                    {{ material.title }}
                                </p>
                                <div class="card-title text-muted mb-0">
                                    Deskripsi:
                                </div>
                                <div class="row">
                                    <div class="col" v-html="material.description"></div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="card-title text-muted mb-0">
                                            File:
                                        </div>
                                        <ol class="pl-4 mb-0">
                                            <li v-for="(file, index) in material.files">
                                                <div class="row">
                                                    <div class="col">
                                                        <a href="#" v-on:click.prevent="download(file)" class="h4 font-weight-bold text-dark p-0 mb-0">
                                                            <file-icon v-bind:type="file.fileExtension" class="mr-1"></file-icon> {{ file.filename }}
                                                        </a>
                                                        <p class="text-muted mb-1">
                                                            {{ file.description }}
                                                        </p>
                                                    </div>
                                                    <div class="col-auto">
                                                        <router-link class="btn btn-danger btn-sm" v-bind:to="{ name: 'material/subject/log', params: {gradeID: gradeSubject.gradeID, gradeSubjectID: gradeSubject.id, type: 'file', reference: file.id} }">
                                                            Log Aktifitas
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </li> 
                                        </ol>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="card-title text-muted mb-0">
                                            Video:
                                        </div>
                                        <div class="row">
                                            <div class="col-4" v-for="(video, index) in material.videos">
                                                <button type="button" class="btn btn-link p-0" v-on:click="videoReference = video">
                                                    <img v-bind:src="'https://img.youtube.com/vi/' + video.url + '/0.jpg'" class="img-fluid" />
                                                </button>
                                                <p class="text-center">
                                                    {{ video.description }}
                                                </p>
                                                <div class="text-center">
                                                    <router-link class="btn btn-danger btn-sm" v-bind:to="{ name: 'material/subject/log', params: {gradeID: gradeSubject.gradeID, gradeSubjectID: gradeSubject.id, type: 'video', reference: video.id} }">
                                                        Log Aktifitas
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-12 mb-5" v-if="roleElligibleModified()">
                <form v-on:submit.prevent="add" disabled>
                    <div class="wrapper-input">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Materi Baru
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="font-weight-medium required text-muted">Judul</label>
                                            <input v-model="form.title" class="form-control form-control-sm" placeholder="Judul" required />
                                        </div>
                                        <div class="form-group">
                                            <label class="font-weight-medium required text-muted">Deskripsi Umum</label>
                                            <tinymce id="text-editor-add" v-model="form.description" v-bind:other_options="tinyMCEOptions"></tinymce>
                                        </div>
                                        <div class="form-group">
                                            <label class="font-weight-medium required text-muted">Deskripsi</label>
                                            <textarea v-model="form.subtitle" class="form-control form-control-sm"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 col-md-6 mb-5">
                                                <label class="font-weight-medium text-muted">File</label>
                                                <ol class="pl-4 mb-0">
                                                    <li v-for="(file, index) in form.files">
                                                        <div class="row align-items-center justify-content-end">
                                                            <div class="col text-dark h4 mb-0 font-weight-medium">
                                                                <file-icon v-bind:type="file.fileExtension" class="mr-1"></file-icon> {{ file.filename }}
                                                            </div>
                                                            <div class="col-auto ml-auto">
                                                                <button class="btn btn-link btn-sm" type="button" v-on:click="removeFile(false, index)">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <input v-model="file.description" class="form-control form-control-sm mt-1 mb-3" placeholder="Deskripsi..." />
                                                            </div>
                                                        </div>
                                                    </li> 
                                                </ol>
                                                <input id="file-add-material" type="file" class="form-control" v-on:change="addFiles($event, false)" placeholder="Upload File" multiple="true" />
                                                <label for="file-add-material" class="btn btn-danger btn-sm px-4">
                                                    Upload File
                                                </label>
                                            </div>
                                            <div class="col-12 col-md-6 mb-5">
                                                <label class="font-weight-medium text-muted">Video</label>
                                                <div class="row">
                                                    <div class="col-12 mb-3" v-for="(video, index) in form.videos">
                                                        <div class="row align-items-center justify-content-end">
                                                            <div class="col-auto ml-auto">
                                                                <button class="btn btn-link btn-sm" type="button" v-on:click="removeVideo(false, index)">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <div class="input-group input-group-sm mb-2">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text">https://youtube.com/watch?v=</span>
                                                                    </div>
                                                                    <input v-model="video.url" class="form-control form-control-sm" placeholder="Youtube ID..." required />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <input v-model="video.description" class="form-control form-control-sm" placeholder="Deskripsi..." />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button class="btn btn-danger btn-sm px-4" type="button" v-on:click="addVideo(false)">
                                                    + Add Video
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="ml-auto col-auto">
                                        <button type="submit" class="btn btn-danger btn-sm px-5">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="toggleInput($event)">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="toggle-input">
                        <button type="button" class="btn btn-sm btn-danger px-5 pull-right" v-on:click="toggleInput($event)">
                            + Create Materi
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modal.remove" v-on:hide="removeReference = null" content-class="border-0" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus bahan ajar ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal v-model="modal.player" v-on:hide="videoReference = null" modal-class="border-0" v-bind:centered="true" v-bind:hide-footer="true" v-bind:hide-header="true" body-class="p-0" size="lg">
            <div v-if="videoReference" class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" v-bind:src="'https://www.youtube.com/embed/' + videoReference.url" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>    
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import tinymce from 'vue-tinymce-editor';
    import FileIcon from "@/components/item/FileIcon";
    import { tinyMCEOptions } from '@/params.js';
    import qs from 'qs';

    /**
     * @param {Object} tryoutSubject
     */
    export default {
        name: "MaterialView",
        components: {
            FileIcon,
            tinymce
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            term() {
                this.fetchMaterial();
            },
            videoReference(videoReference) {
                if (videoReference) {
                    this.modal.player = true;
                }
            }
        },
        data() {
            return {
                form: {
                    title: '',
                    description: '',
                    subtitle: '',
                    files: [],
                    videos: []
                },
                gradeSubject: {subject: {}, grade: {}},
                materials: [],
                modal: {
                    remove: false,
                    player: false
                },
                removeReference: null,
                videoReference: null,
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            confirmation(model) {
                this.modal.remove = true;
                this.removeReference = model;
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchMaterial();
                    }
                } else {
                    this.fetchMaterial();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            save(event) {
                this.axios.post(process.env.API_URL + '/grade-subject/update/' + this.gradeSubject.id, this.gradeSubject).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            add() {
                let formData = new FormData();
                for (let attribute in this.form) {
                    if (Array.isArray(this.form[attribute])) {
                        for (let i = 0; i < this.form[attribute].length; i++) {
                            for (let additional in this.form[attribute][i]) {
                                formData.set(attribute + '[' + i + '][' + additional + ']', this.form[attribute][i][additional]);
                            }
                        }
                    } else {
                        formData.set(attribute, this.form[attribute]);
                    }
                }
                formData.set('gradeSubjectID', this.gradeSubject.id);
                formData.set('termID', this.term.id);
                this.axios.post(process.env.API_URL + '/teaching-material', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
//                        this.toggleInput(event);
                        location.reload();
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            update(event, index) {
                let material = this.materials[index];
                if (material) {
                    let formData = new FormData();
                    for (let attribute in material) {
                        if (!Array.isArray(material[attribute]) && !(material[attribute] instanceof Object)) {
                            formData.set(attribute, material[attribute]);
                        }
                    }
                    let additionals = ['files', 'videos'];
                    additionals.forEach(function (additional) {
                        for (let i = 0; i < material[additional].length; i++) {
                            for (let attribute in material[additional][i]) {
                                let value = material[additional][i][attribute];
                                formData.set(additional + '[' + i + '][' + attribute + ']', value ? value : '');
                            }
                        }
                    });
                    this.axios.post(process.env.API_URL + '/teaching-material/update/' + material.id, formData).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.toggleInput(event);
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            remove() {
                if (this.removeReference) {
                    this.axios.post(process.env.API_URL + '/teaching-material/delete/' + this.removeReference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchMaterial();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modal.remove = false;
                        this.removeReference = null;
                    });
                }
            },
            removeVideo(materialIndex, index) {
                if (Number.isInteger(materialIndex)) {
                    let videos = this.materials[materialIndex].videos;
                    let video = videos[index];
                    if (video.id) {
                        if (confirm('Hapus video bahan ajar? Video tidak dapat dikembalikan.')) {
                            this.axios.post(process.env.API_URL + '/teaching-material/delete-video/' + video.id).then(response => {
                                if (response.data.status) {
                                    this.$toastr('success', response.data.message, 'Success');

                                    videos.splice(index, 1);
                                } else {
                                    this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                                }
                            });
                        }
                    } else {
                        videos.splice(index, 1);
                    }
                } else {
                    let videos = this.form.videos;
                    videos.splice(index, 1);
                }
            },
            removeFile(materialIndex, index) {
                if (Number.isInteger(materialIndex)) {
                    let files = this.materials[materialIndex].files;
                    let file = files[index];
                    if (file.id) {
                        if (confirm('Hapus file bahan ajar? File tidak dapat dikembalikan.')) {
                            this.axios.post(process.env.API_URL + '/teaching-material/delete-file/' + file.id).then(response => {
                                if (response.data.status) {
                                    this.$toastr('success', response.data.message, 'Success');

                                    files.splice(index, 1);
                                } else {
                                    this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                                }
                            });
                        }
                    } else {
                        files.splice(index, 1);
                    }
                } else {
                    let files = this.form.files;
                    files.splice(index, 1);
                }
            },
            download(file) {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/teaching-material/download-file/' + file.id + '?' + qs.stringify({token: token, termID: this.term.id}, {encode: false});
            },
            extension(filename) {
                let parts = filename.split('.');
                return parts.length ? parts.pop() : '';
            },
            fetchMaterial() {
                this.axios.all([
                    this.axios.get(process.env.API_URL + '/grade-subject/' + this.$route.params.gradeSubjectID),
                    this.axios.get(process.env.API_URL + '/teaching-material', {params: {gradeSubjectID: this.$route.params.gradeSubjectID, termID: this.term.id}})
                ]).then(this.axios.spread(function (responseGradeSubject, responseMaterial) {
                    this.gradeSubject = responseGradeSubject.data.data;
                    let materials = responseMaterial.data.data;
                    for (let i = 0; i < materials.length; i++) {
                        materials[i]['files'] = materials[i].teachingMaterialFiles;
                        materials[i]['videos'] = materials[i].teachingMaterialVideos;
                    }
                    this.materials = materials;

                    document.title = 'Bahan Ajar ' + this.gradeSubject.grade.name + ' - ' + this.gradeSubject.subject.name + ' - ' + process.env.APP_NAME;
                }.bind(this)));
            },
            addFiles(event, index) {
                var input = event.currentTarget;
                if (input.files && input.files.length) {
                    if (Number.isInteger(index)) {
                        let material = this.materials[index];
                        if (material) {
                            for (let i = 0; i < input.files.length; i++) {
                                material.files.push({
                                    filename: input.files[i].name,
                                    fileExtension: this.extension(input.files[i].name),
                                    description: '',
                                    file: input.files[i]
                                });
                            }
                        }
                    } else {
                        for (let i = 0; i < input.files.length; i++) {
                            this.form.files.push({
                                filename: input.files[i].name,
                                fileExtension: this.extension(input.files[i].name),
                                description: '',
                                file: input.files[i]
                            });
                        }
                    }
                }
            },
            addVideo(index) {
                if (Number.isInteger(index)) {
                    let material = this.materials[index];
                    if (material) {
                        material.videos.push({
                            url: '',
                            description: ''
                        });
                    }
                } else {
                    this.form.videos.push({
                        url: '',
                        description: ''
                    });
                }
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isCoordinator);
            },
            overrideTinyMCEOptions() {
                this.tinyMCEOptions = Object.assign({}, this.tinyMCEOptions, {
                    file_picker_callback: function (callback) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');
                        input.style.visibility = 'hidden';
                        input.style.position = 'absolute';

                        input.onchange = function () {
                            var file = input.files[0];
                            if (file) {
                                let formData = new FormData;
                                formData.set('image', file);
                                this.axios.post(process.env.API_URL + '/solution/uploadImage', formData).then(response => {
                                    if (response.data.status) {
                                        callback(response.data.location, {alt: file.name});
                                    }
                                });
                            }
                        }.bind(this);
                        input.click();
                    }.bind(this)
                });
            }
        },
        created() {
            this.overrideTinyMCEOptions();
            this.fetchMaterial();
        }
    };
</script>

<style scoped>
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }

    h1:empty, h2:empty, h3:empty, h4:empty, h5:empty, h6:empty,
    p:empty, .text-loading:empty, img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/material/View.vue